<template>
  <div class="ui basic segment">
    <div v-if="prototype && prototype.setup">
      <div class="ui six link cards">
        <div
          class="card"
          v-for="page in prototype.setup.pages"
          v-bind:key="page.id"
          v-on:click="go_to_page(page)"
          style="margin: 10px 10px !important"
        >
          <div class="content">
            <h3 class="ui icon header" style="margin-bottom:0">
              <img
                src="/images/icons/generic_prototype.jpeg"
                class="ui image"
              />
              <div class="content" style="margin-top:8px">
                {{ page.name }}
              </div>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";
import filters from "@/filters";

export default {
  name: "PrototypeViewerIndex",
  components: {},
  filters: filters,
  data() {
    return {
      prototype: {},
    };
  },
  methods: {
    go_to_page(page) {
      let vm = this;
      this.$router.push({
        name: "PrototypePageViewer",
        query: { m: vm.prototype.uuid, p: page.id },
      });
    },
  },
  created() {},
  mounted() {
    let vm = this;
    let uuid = this.$route.query.i;
    local_api(vm, "post", "/prototype/viewer/do-get", { i: uuid })
      .then((mdle) => {
        vm.prototype = mdle;

        if (mdle && mdle.setup && mdle.setup.pages) {
          let defaultPage = mdle.setup.pages.find((p) => {
            return p.is_main;
          });
          if (defaultPage) {
            vm.$router.replace({
              name: "PrototypePageViewer",
              query: { m: vm.prototype.uuid, p: defaultPage.id },
            });
          }
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
};
</script>
